import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Button, Box, Typography, Paper, CircularProgress } from "@mui/material";
import { loginInitiate } from "../redux/actions/loginAction"; 
import { useNavigate } from "react-router-dom";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Access Redux state
  const { loading, error, isLoggedIn } = useSelector((state) => state.login || {});

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  const handleSubmit = (e) => {
    e.preventDefault();
    const credentials = { username, password };
    dispatch(loginInitiate(credentials, navigate)); 
  };

  return (
    <Paper elevation={3} sx={{ maxWidth: 400, mx: "auto", mt: 8, p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Login
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Username"
          type="text"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value.toUpperCase())}
          required
        />

        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <Button
          variant="contained"
          type="submit"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
        </Button>
      </Box>

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}

      {isLoggedIn && (
        <Typography color="success.main" sx={{ mt: 2 }}>
          Logged in successfully ✅
        </Typography>
      )}
    </Paper>
  );
}
